document.addEventListener('teeinblue-event-after-cart-added', function() {
  fetch('/cart.js', { method: 'GET' })
  .then((response) => response.json())
  .then((cart) => {
    const cartCountList = document.querySelectorAll('cart-count')

    cartCountList.forEach((item) => {
      if (cart.item_count > 99) {
        item.innerHTML = `<span class="text-sm">99+</span>`;
        item.classList.add('cart-count--small-medium');
      } else {
        item.innerText = cart.item_count;
        item.classList.remove('cart-count--small-medium');
      }
      item.hidden = item.itemCount === 0;
  
      const method = item.itemCount === 0 ? 'remove' : 'add';
      document.documentElement.classList[method]('cart-has-items');
    })

    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        detail: {
          cart: cart,
        },
      })
    );
  })
  .catch((error) => {
    console.error('Error refreshing cart drawer:', error);
  });

  const sectionId = FoxTheme.utils.getSectionId(document.querySelector('cart-items'));

  fetch(`/?section_id=${sectionId}`)
    .then((response) => response.text())
    .then((html) => {
      const parser = new DOMParser();
      const documentHTML = parser.parseFromString(html, 'text/html');

      const cartDrawerBodyUpdate = documentHTML.querySelector(`#CartDrawerBody-${sectionId}`);
      const cartDrawerFooterUpdate = documentHTML.querySelector(`#CartDrawerFooter-${sectionId}`);
      const cartDrawerEmptyUpdate = documentHTML.querySelector(`#CartDrawerEmpty-${sectionId}`);

      const cartDrawerBody = document.querySelector(`#CartDrawerBody-${sectionId}`);
      const cartDrawerFooter = document.querySelector(`#CartDrawerFooter-${sectionId}`);
      const cartDrawerEmpty = document.querySelector(`#CartDrawerEmpty-${sectionId}`);

      if (cartDrawerBodyUpdate) {
        cartDrawerBody.innerHTML = cartDrawerBodyUpdate.innerHTML;
      }
      if (cartDrawerFooterUpdate) {
        cartDrawerFooter.innerHTML = cartDrawerFooterUpdate.innerHTML;
      }
      if (cartDrawerEmptyUpdate) {
        cartDrawerEmpty.innerHTML = cartDrawerEmptyUpdate.innerHTML;
      }

      const itemCount = documentHTML.querySelector(`#CartDrawerBody-${sectionId} .cart-item`);
      if (itemCount) {
        cartDrawerBody.classList.remove('hidden');
        cartDrawerFooter.classList.remove('hidden');
        cartDrawerEmpty.classList.add('hidden');
      } else {
        cartDrawerBody.classList.add('hidden');
        cartDrawerFooter.classList.add('hidden');
        cartDrawerEmpty.classList.remove('hidden');
      }
    })
    .catch((error) => console.error('Error refreshing cart drawer:', error));

    document.querySelector('cart-drawer')?.show()

})